module.exports = "/assets/9e230566d8386a35ef5a84d65cdec22f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/NX.png
// module id = 2786
// module chunks = 0